import {memo, ReactNode} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';

interface CardAttendeesInfoProps {
  children: ReactNode;
  onClick: (e: React.MouseEvent) => void;
}

export const CardAttendeesInfo = memo(
  ({children, onClick}: CardAttendeesInfoProps) => {
    return <AttendeesWrapper onClick={onClick}>{children}</AttendeesWrapper>;
  },
);

const AttendeesWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    justify-content: space-between;
  }
`;
